import React from 'react'
import DocumentCommentStats from './DocumentCommentStats';
import { Link } from 'react-router-dom';

function DocumentTile(props) {


    return (
        <div>
            <div className="document-tile">
                <div className="document-tile-metadata">
                    <h4><Link to={"/Details/" + props.documentId + "/" + props.urlTitle}>{props.title}</Link></h4>
                    <p><b>{props.prettySignedDate}</b></p>
                    <p>{props.summary}...</p>
                    <br />
                </div>
                <div className="document-tile-stats">
                    <DocumentCommentStats documentId={props.documentId}></DocumentCommentStats>
                </div>
            </div>
            <hr />
        </div>

    )
}

export default DocumentTile;